<template>
  <div
    class="page-wrapper compact-wrapper"
    id="pageWrapper"
    style="height: 0px !important"
  >
    <!-- BEGIN: Header-->
    <Topbar v-if="userData?.role?.role_id" />
    <!-- END: Header-->
    <!-- <div class="page-body-wrapper"> -->
    <!-- Sidebar -->
    <!-- <div
        class="main-menu menu-fixed menu-light menu-accordion"
        v-bind:class="isOpen ? 'mobileMenu' : ''"
      > -->
    <SideBar2 v-if="userData?.role?.role_id" />
  </div>

  <!-- END -->

  <!-- BEGIN: Content-->
  <router-view></router-view>
  <!-- END: Content-->

  <!-- <div
      class="sidenav-overlay"
      v-bind:class="{ dblock: isOpen }"
      @click="openClose"
    ></div> -->
  <!-- </div> -->
</template>

<script type="javascript">
// import SideBar from './layout/sideBar.vue';
import EventBus from '../common/EventBus';
// import TopHeader from './layout/top_header_nav.vue';\
import Topbar from './layout/topbar';
import SideBar2 from './layout/SideBar2';
import userAPI from '../services/user.API';

export default {
  components: {
    Topbar,
    SideBar2,
    // TopHeader,
    // SideBar,
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    getUserProfileRole() {
      return true
      // this.$store.state.profile.role_id;
    },
  },
  mounted() {
    // this.URL = IMG_URL;

    EventBus.on('logout', () => {
      this.logOut();
    });

    userAPI.getUserProfile().then(
      (res) => {
        // console.log("success");
        this.userData = res?.data?.data;
      },(err) => {
        if (err?.response?.data?.success === false) {
          this.$store.dispatch("auth/logout");
          this.$store.dispatch("profile/logout");
          this.$store.dispatch("notification/logout");
          this.$router.push("/login");
          // this.$moshaToast(err?.response?.data?.message, {
          //   position: "top-right",
          //   type: "danger",
          //   transition: "bounce",
          //   showIcon: "true",
          //   timeout: 2000,
          // });
        }
      }

    );
  },

  data() {
    return {
      user: '',
      userId: '',
      URL: '',
      isOpen: false,
      userData:{}
    };
  },
  methods: {
    openClose() {
      this.isOpen = !this.isOpen;
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
  beforeUnmount() {
    EventBus.remove('logout');
  },

};
</script>
<style>
body {
  font-family: "Poppins";
}
.header-navbar .navbar-container ul.nav li.dropdown .dropdown-menu {
  top: 60px;
  left: auto;
  right: 0;
  padding-top: 0;
  max-height: 45rem;
}
.nav.navbar-nav.float-right .dropdown.dropdown-notification .dropdown-menu::before {
  background: #017a7c;
  z-index: -1;
}
.nav.navbar-nav.float-right .dropdown.dropdown-user .dropdown-menu::before {
  background: #fff;
  z-index: -1;
}
.error-feedback {
  color: red;
  font-size: 12px;
}
</style>
